import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class FormSettings extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "FormSettings";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {

      redirect: {
        allow_add_tags: true,
        allow_edit_tags: true,
        allow_partial_payments: true,
        approved_url: null,
        declined_url: null,
        error_url: null,
        enable_discounts: true,
        enable_fees: true,
        enable_taxes: true,
        expiration_hours: 72,
        id_counter: 1000,
        id_edit: true,
        id_prefix: null,
        id_suffix: null,
        tags: [],
        default_tags: [],
      },

      invoice: {
        allow_add_tags: true,
        allow_edit_tags: true,
        allow_partial_payments: true,
        approved_url: null,
        declined_url: null,
        enable_discounts: true,
        enable_fees: true,
        enable_taxes: true,
        error_url: null,
        expiration_hours: 72,
        id_counter: 1000,
        id_edit: true,
        id_prefix: null,
        id_suffix: null,
        tags: [],
        default_tags: [],
        terms: [],
      },

      modal: {
        allow_add_tags: true,
        allow_edit_tags: true,
        allow_partial_payments: true,
        approved_url: null,
        declined_url: null,
        enable_discounts: true,
        enable_fees: true,
        enable_taxes: true,
        error_url: null,
        expiration_hours: 72,
        id_counter: 1000,
        id_edit: true,
        id_prefix: null,
        id_suffix: null,
        tags: [],
        default_tags: [],
      },

      email: {
        allow_add_tags: true,
        allow_edit_tags: true,
        id_counter: 1000,
        id_edit: true,
        id_prefix: null,
        id_suffix: null,
        tags: [],
        default_tags: [],
      },

      checkout: {
        enable_receipts: true,
        bcc_email: [],
        allow_partial: true,
        enable_portal: false,
        require_phone: false,
        credit_card: {
          is_enabled: true,
          require_billing_address: true,
          add_terms: true,
          terms_markup: null,
          terms_link: null,
          use_terms_markup: true,
        },
        ach: {
          is_enabled: true,
          require_bank_info: false,
          add_terms: true,
          terms_markup: null,
          terms_link: null,
          use_terms_markup: true,
        },
        shipping: {
          is_enabled: false
        }
      },

      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {
    // use this for transforming your data, e.g. transform a Date-string into a Date object; see: https://vuex.feathersjs.com/model-classes.html#setupinstance
    return data;
  }
}
